// document.getElementById("HeaderMenu-faqs").setAttribute("href", "https://wbpwholesale.myshopify.com/pages/faqs");
// document.getElementById("HeaderMenu-contact").setAttribute("href", "https://wbpwholesale.myshopify.com/pages/contact");
// document.getElementById("HeaderMenu-back-to-retail-site").setAttribute("href", "https://www.womensbeanproject.com/");
// document.getElementById("refundPolicyLink").setAttribute("href", "https://wbpwholesale.myshopify.com/pages/return-and-refund-policy");




// Select the container by its ID
const tabContainer = document.getElementById('wof_tab_container');

// Check if tabContainer exists before appending
if (tabContainer) {
    // Check if the "Products" tab already exists by checking inner content or other criteria
    if (!document.querySelector('#wof_tab_container a[href="https://wbpwholesale.myshopify.com/collections/all"]')) {
        // Create a new anchor tag for the "Products" tab
        const newTab = document.createElement('a');

        // Set the necessary attributes and content for the anchor tag
        newTab.href = 'https://wbpwholesale.myshopify.com/collections/all'; // Set your desired URL here
        newTab.innerText = 'Browse'; // Set the text for the new tab
       
      newTab.classList.add('tab', 'custom-tab'); // Add your custom class

        // Insert the new tab at the start of the container
        tabContainer.insertBefore(newTab, tabContainer.firstChild);
    } else {
        console.log("The 'Products' tab already exists.");
    }
} else {
    
}


/* For slider on product IMGS */

document.addEventListener('DOMContentLoaded', function () {
    const listItems = document.querySelectorAll('ul.product__media-list > li');

    const inactiveItems = []; // Array to collect inactive items

    listItems.forEach((item, index) => {
        if (index !== 0 && !item.classList.contains('is-active')) {
            // Collect inactive items
            inactiveItems.push(item);
        }
    });

    // Check if there are more than 1 inactive items
    if (inactiveItems.length >= 1) {
        // Create Swiper slider after a 100ms delay
        setTimeout(() => {
            const swiperContainer = document.createElement('div');
            swiperContainer.classList.add('swiper-container');

            // Set custom height and width for the slider
            swiperContainer.style.width = '100%';  // Set desired width (e.g., 80% of the parent container)
            swiperContainer.style.height = '250px';  // Set desired height (e.g., 300px)
            swiperContainer.style.overflow = 'hidden';  // Hide overflow (important for hiding out-of-bound slides)

            const swiperWrapper = document.createElement('div');
            swiperWrapper.classList.add('swiper-wrapper');
            swiperContainer.appendChild(swiperWrapper);

            // Move inactive items into the swiper-wrapper as swiper slides
            inactiveItems.forEach(item => {
                const slide = document.createElement('div');
                slide.classList.add('swiper-slide');

                // Clone the item
                const clonedItem = item.cloneNode(true);
                slide.appendChild(clonedItem);
                swiperWrapper.appendChild(slide);
            });

            // Insert the swiper-container AFTER the product list
            const productList = document.querySelector('ul.product__media-list');
            productList.parentNode.insertBefore(swiperContainer, productList.nextSibling);

            // Hide original inactive items
            inactiveItems.forEach(item => item.style.display = 'none');

            // Create navigation buttons and pagination dots
            const swiperPrevButton = document.createElement('div');
            swiperPrevButton.classList.add('swiper-button-prev');
            swiperContainer.appendChild(swiperPrevButton);

            const swiperNextButton = document.createElement('div');
            swiperNextButton.classList.add('swiper-button-next');
            swiperContainer.appendChild(swiperNextButton);

            const swiperPagination = document.createElement('div');
            swiperPagination.classList.add('swiper-pagination');
            swiperContainer.appendChild(swiperPagination);

            const swiperScrollbar = document.createElement('div');
            swiperScrollbar.classList.add('swiper-scrollbar');
            swiperContainer.appendChild(swiperScrollbar);

            // Initialize Swiper
            const swiper = new Swiper(swiperContainer, {
                slidesPerView: 3.5,  // Number of slides visible at a time
                spaceBetween: 12,  // Space between slides
                loop: false,       // Disable looping for now
                slidesPerGroup: 1, // Slide one item at a time
                navigation: {
                    nextEl: swiperNextButton, // Add the custom next button
                    prevEl: swiperPrevButton, // Add the custom prev button
                },
                pagination: {
                    el: swiperPagination,     // Enable pagination dots
                    clickable: true,          // Allow dots to be clickable
                },
                scrollbar: {
                    el: swiperScrollbar,      // Enable a scrollbar
                    draggable: true,          // Allow the scrollbar to be dragged
                },
            });
        }, 100); // Delay for 100 milliseconds
    }
});

/* End For slider on product IMGS */





/* 50 state on option in registration form */

// Array of the 50 U.S. states
const states = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
    "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
    "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
    "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
    "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
    "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
    "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia",
    "Washington", "West Virginia", "Wisconsin", "Wyoming"
];

// Function to filter out invalid states
function filterInvalidStates() {
    const stateDropdown = document.getElementById('101223');
    const optionsToRemove = [];

    // Iterate through the options and find invalid states
    for (let i = 0; i < stateDropdown.options.length; i++) {
        const option = stateDropdown.options[i];
        if (!states.includes(option.value) && option.value !== "") {
            optionsToRemove.push(i); // Store index of invalid option
        }
    }

    // Remove options in reverse order to avoid index shifting
    for (let i = optionsToRemove.length - 1; i >= 0; i--) {
        stateDropdown.remove(optionsToRemove[i]);
    }
}

// Call the function after a 2-second delay
setTimeout(filterInvalidStates, 2000);



/* End 50 state on option in registration form */

/* Add Notify Me Button On Qucik Order Page */


document.addEventListener('DOMContentLoaded', function () {
  // Delay the execution by 5 seconds to ensure all content is loaded
  setTimeout(function () {
    // Select all rows that contain product IDs
    const productRows = document.querySelectorAll('tr');

    productRows.forEach(function (row) {
      // Find the 'Out of stock' button within each row
      const outOfStockButton = row.querySelector('.wof-sold-out-button');

      // Check if the 'Out of stock' button exists and has the text 'Out of stock'
      if (outOfStockButton && outOfStockButton.textContent.trim() === 'Out of stock') {
        // Get the product title
        const productTitleElement = row.querySelector('.wof-product-title');
        if (productTitleElement) {
          const productTitle = productTitleElement.textContent.trim();

          // Convert the title to a handle (lowercase, replace spaces and special chars with dashes)
          const productHandle = productTitle
            .toLowerCase()
            .replace(/[^a-z0-9\s\-]/g, '') // Remove non-alphanumeric characters except spaces and hyphens
            .replace(/\s+/g, '-') // Replace spaces with a single hyphen
            .replace(/\-+/g, '-') // Replace multiple hyphens with a single hyphen

          // Check if the original link is already set in the row
          let originalLink = outOfStockButton.getAttribute('data-original-link');

          // If not set, assign the original link
          if (!originalLink) {
            originalLink = `/products/${productHandle}`;
            outOfStockButton.setAttribute('data-original-link', originalLink);
          }

          // Create the "Notify Me" link or button
          const notifyMeButton = document.createElement('a');
          notifyMeButton.classList.add('notify-me-btn');
          notifyMeButton.textContent = 'Notify me when available';
          notifyMeButton.href = originalLink; // Always use the original link
          notifyMeButton.style.cssText = `
            display: inline-block;
            margin-left: 10px;
            padding: 5px 10px;
            background-color: #B1501F;
            color: #fff;
            text-decoration: none;
            border: 1px solid #B1501F;
            float: right;
            font-weight: bold;
          `;

          // Find the price element and insert the Notify Me button in the same cell
          const priceCell = row.querySelector('.wof-price').parentNode;

          if (priceCell) {
            // Remove existing Notify Me button if it exists
            const existingNotifyButton = priceCell.querySelector('.notify-me-btn');
            if (existingNotifyButton) {
              priceCell.removeChild(existingNotifyButton);
            }

            // Append the "Notify Me" link/button after the price
            priceCell.appendChild(notifyMeButton);
          }
        }
      }
    });
  }, 1000); // Delay for 1 seconds (1000 milliseconds)
});



$(document).ready(function() {
  // Disable the custom validation message for the 'Purchase Order Number' field
  var $poField = $('#purchase-order-number');

  // Clear any default validation message
  $poField.on('invalid', function(event) {
    event.preventDefault(); // Prevent the browser from showing the validation bubble
    this.setCustomValidity('');
  });

  // Optional: If you want to allow validation for other fields
  $poField.on('input', function() {
    this.setCustomValidity('');
  });
    var $cartNotification = $('.cart-notification-wrapper');

    // Check if the div has the 'page-width' class
    if ($cartNotification.hasClass('page-width')) {
        // Remove the 'page-width' class
        $cartNotification.removeClass('page-width');
    }
});



function toggleDescription() {
  const shortDesc = document.getElementById('short-description');
  const fullShortDesc = document.getElementById('full-short-description');
  const fullDesc = document.getElementById('full-description');
  const viewMore = document.getElementById('view-more');
  const viewLess = document.getElementById('view-less');

  // If full description is hidden, show it
  if (fullDesc.style.display === 'none') {
    shortDesc.style.display = 'none'; // Hide truncated short description
    fullShortDesc.style.display = 'block'; // Show full short description
    fullDesc.style.display = 'block'; // Show full product description
    viewMore.style.display = 'none'; // Hide View More link
    viewLess.style.display = 'block'; // Show View Less link
  } else {
    shortDesc.style.display = 'block'; // Show truncated short description
    fullShortDesc.style.display = 'none'; // Hide full short description
    fullDesc.style.display = 'none'; // Hide full product description
    viewMore.style.display = 'block'; // Show View More link
    viewLess.style.display = 'none'; // Hide View Less link
  }
}


// This function for when we click on product from shop page then on click hid the sidebar popup and opend a product detail page
// Function to handle product click
function handleProductClick(productId) {
    console.log("productId: " + productId);
    // Hide the sidebar and overlay immediately
    $("#desc_popup, #desc_popup_overlay").hide();

    // Set a timeout to allow the hidden sidebar content to load
    setTimeout(function() {
        // Find the main sidebar div
        var sidebarMainDiv = $('#desc_popup');
        
        // Ensure the sidebar exists
        if (sidebarMainDiv.length) {
            console.log("Sidebar found, searching for the link...");

            // Find the link inside the sidebar
            var link = sidebarMainDiv.find('#desc_action_wrapper a');

            // Check if the link exists and has a valid href
            var linkHref = link.attr('href');
            if (link.length && linkHref) {
                link.removeAttr('target');
                console.log("Link found with href: " + linkHref);
                link[0].click(); // Trigger a real click on the link
               // window.location.href = linkHref; 
            } else {
                console.log("Link not ready, retrying...");

                // Retry after a short delay if the href is missing
                setTimeout(function() {
                    var retryLinkHref = link.attr('href');
                    if (retryLinkHref) {
                        console.log("Link href after retry: " + retryLinkHref);
                        link.removeAttr('target');                        
                        link[0].click(); // Trigger the click again
                        // window.location.href = linkHref; 
                    } else {
                        console.log("Link href is still undefined after retry.");
                    }
                }, 300); // Retry after 300ms
            }
        } else {
            console.log("Sidebar not found for product ID: " + productId);
        }
    }, 500); // Adjust the timeout delay if necessary
}

// Event handler for both product title and image clicks on shop page
$(document).on('click', '.wof-product-title, .wof-product-image', function(event) {
    event.preventDefault(); // Prevent the default action (like opening a sidebar)

    // Get the dynamically assigned product ID from the clicked element
    var productId = $(this).data('product-id'); 
    handleProductClick(productId); // Call the common function with product ID
});

// document.addEventListener("DOMContentLoaded", function () {
//     // Select all the headings inside the specific structure
//     const blogHeadings = document.querySelectorAll(".card__content .card__information h3.card__heading");

//     blogHeadings.forEach((heading) => {
//         // Create the link dynamically
//         const link = document.createElement("a");
//         link.href = "/blogs/case-studies/case-study-first-presbyterian-church-of-stillwater-minnesota";
//         link.className = "full-unstyled-link";
//         link.setAttribute("aria-labelledby", ""); // Add aria-labelledby if required
//         link.textContent = "Case Study: First Presbyterian Church of Stillwater, Minnesota";

//         // Append the link to the heading
//         heading.innerHTML = ""; // Clear any existing content
//         heading.appendChild(link);
//     });
// });
$(document).ready(function(){
  $('.blog-images-slider').slick({
    autoplay: true,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});


document.addEventListener("DOMContentLoaded", function() {
    // Select all blog list containers by class name
    const blogSections = document.querySelectorAll(".articles-wrapper");

    blogSections.forEach(section => {
        // Find all list items within the current blog section
        const articles = section.querySelectorAll("li.blog__post");

         if (articles.length === 1) {
            // Apply styles to center a single post with 20% padding on left and right
            section.style.display = "flex";
            section.style.justifyContent = "center"; // Center content horizontally

            const article = articles[0];
            article.style.width = "60%"; // Set width to 60% to allow 20% padding on each side
            article.style.maxWidth = "70%"; // Optional: Set a max width for readability
            article.style.margin = "0 20%"; // 20% margin on left and right for centering
            article.style.textAlign = "center"; // Center text inside the article
            article.style.display = "flex";
            article.style.flexDirection = "column";
            article.style.alignItems = "center"; // Center all child elements

            // Center the heading and text within the article
            const heading = article.querySelector(".card__heading");
            const text = article.querySelector(".article-card__excerpt");

            if (heading) {
                heading.style.textAlign = "center";
            }
            if (text) {
                text.style.textAlign = "center";
            }
        }
    });
});



   $('.card__information a').each(function() { 
    $(this).attr('aria-labelledby', '') 
   });
  
    // $('#MainContent img').each(function() {
    //     if (!$(this).attr('alt')) {
    //       $(this).attr('alt', '');  // You can customize this description
    //     }
    // });


$(document).ready(function () {
  setTimeout(function () {
    // Create the <h1> element first
    var h1 = $("<h1>").addClass("blog__title inline-richtext h1 catalog-heading").text("Catalog");
    // Insert the <h1> element before the target container
    $("#wof_tab_container").before(h1);
  }, 1000); // Delay of 1 second
  
  // home page h2 change to h1 start
    var count = $('.rich-text__heading.rte.inline-richtext.h1').length;
    if (count > 0) {
        $('.rich-text__heading.rte.inline-richtext.h1').first().replaceWith(function() {
            return $('<h1>', {
                html: $(this).html(),
                class: $(this).attr('class')
            });
        });
    }
  // home page h2 change to h1 end
});
// side cart close function
jQuery(document).on('click', '.boost-sd__modal-close-btn--on-overlay', function() {
    jQuery("#boost-sd__modal-card").remove();
});

$(document).ready(function() {
  // Check the number of <li> elements in the .blog__posts container
  if ($('ul.blog__posts li').length <= 1) {
    // Hide the slider buttons if there's only one or no <li> elements
    $('.slider-buttons').hide();
  }
});








